import { Pagination } from 'react-admin';

const Paginator = (props: any) => (
  <Pagination 
    rowsPerPageOptions={[10, 25, 50, 100, 1000]} 
    {...props} 
  />
);

export const paginationProps = {
  pagination: <Paginator />,
  perPage: 1000,
};
